module.exports = __webpack_public_path__ + "img/40_discount2.7baf679f.png";